<div class="issue-form-dialog">
    <form [formGroup]="formDialog">
        <div class="d-flex orang-title align-items-center">
            <div class="orang-text">הפקת טופס חופשות למוסד</div>
            <div class="orang-line"></div>
        </div>

        <div class="form-body">
            <div class="form-row">
                <label class="txt">מתאריך</label>
                <div class="field-wrap">
                    <input class="inputText" type="date" formControlName="fromDate"
                        [ngClass]="{required: isSubmited && formDialog.controls.fromDate.errors}">
                    <span class="error-text" *ngIf="isSubmited && formDialog.controls.fromDate.errors">שדה חובה</span>
                </div>
            </div>

            <div class="form-row">
                <label class="txt">עד תאריך</label>
                <div class="field-wrap">
                    <input class="inputText" type="date" formControlName="toDate"
                        [ngClass]="{required: isSubmited && formDialog.controls.toDate.errors}">
                    <span class="error-text" *ngIf="isSubmited && formDialog.controls.toDate.errors">שדה חובה</span>
                </div>
            </div>

            <div class="form-row logo-row">
                <label class="txt">לוגו</label>
                <app-logo-field [logo]="logo" [loading]="logoLoading" [busy]="logoBusy" [error]="logoError"
                    (selected)="onLogoSelected($event)"></app-logo-field>
            </div>

            <div class="status-message error" *ngIf="errorMessage">{{ errorMessage }}</div>
            <div class="status-message success" *ngIf="successMessage">{{ successMessage }}</div>
        </div>

        <div class="contant-buttons d-flex justify-content-center">
            <button type="button" class="pill-button primary" (click)="save()" [disabled]="loading">
                <i [hidden]="!loading" class="fa fa-spinner fa-spin"></i>אישור
            </button>
            <button type="button" class="pill-button cancel" (click)="close()">{{ finished ? 'סיום' : 'ביטול' }}</button>
        </div>
    </form>
</div>
